import IntroScreen from 'features/advance/screens/lightning/IntroPage/components/IntroScreen/IntroScreen';
import React from 'react';

export default function IntroPage() {
  return <IntroScreen />;
}
